import { Component } from '@angular/core';
import { FileService } from '../../core/services/file.service';

@Component({
  selector: 'app-home',
  imports: [],
  templateUrl: './home.component.html',
  styleUrl: './home.component.less',
})
export class HomeComponent {
  title = 'Price and Availability application';
  showMenu = true;

  constructor(private fileService: FileService) {}

  downloadManual(): void {
    const filename = 'user_manual.docx';
    this.fileService.downloadFile(filename).subscribe({
      next: (response: any) => {
        if (response.body) {
          const contentDisposition = response.headers.get(
            'Content-Disposition'
          );
          const filename =
            this.getFilenameFromContentDisposition(contentDisposition);
          const blob = new Blob([response.body]);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
        } else {
          console.error('Response body is empty or invalid.');
        }
      },
      error: (error) => {
        console.error('Error downloading file:', error);
      },
    });
  }

  private getFilenameFromContentDisposition(
    contentDisposition: string | null
  ): string {
    if (!contentDisposition) return 'downloaded-file';

    const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(
      contentDisposition
    );
    return matches != null && matches[1]
      ? matches[1].replace(/['"]/g, '')
      : 'downloaded-file';
  }

  previewFlowChart(): void {
    this.fileService.downloadFile('PNA_FlowChart.jpg').subscribe({
      next: (response: any) => {
        if (response.body) {
          const blob = new Blob([response.body], { type: 'image/jpeg' });
          const url = window.URL.createObjectURL(blob);
          window.open(url, '_blank');
          // Optionally revoke after some time
          setTimeout(() => window.URL.revokeObjectURL(url), 10000);
        } else {
          console.error('Response body is empty or invalid.');
        }
      },
      error: (error) => {
        console.error('Error downloading file:', error);
      },
    });
  }
}
